// // src/context/NotificationContext.js
// import React, { createContext, useEffect, useState } from "react";
// import { useSnackbar } from "notistack";
// import socket from "./socket.js";  // <-- correct path if needed
// // NotificationContext.js
// export const NotificationContext = createContext();

// export const NotificationProvider = ({ children }) => {
//   const [notifications, setNotifications] = useState([]);
//   const { enqueueSnackbar } = useSnackbar();

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const userType = localStorage.getItem("userType");

//     const allowedRoles = ["admin", "BSE", "team_leader"];
//     if (token && allowedRoles.includes(userType)) {
//       socket.on("getNotification", (data) => {
//         console.log("🔔 Notification received:", data);
//         enqueueSnackbar(data.message, { variant: "info" });

//         // Add "viewed: false" to mark as unread
//         setNotifications((prev) => [{ ...data, viewed: false }, ...prev]);
//       });

//       return () => {
//         socket.off("getNotification");
//       };
//     }
//   }, [enqueueSnackbar]);

//   const markAllAsViewed = () => {
//     setNotifications((prev) =>
//       prev.map((notif) => ({ ...notif, viewed: true }))
//     );
//   };

//   const unreadNotifications = notifications.filter((notif) => !notif.viewed);

//   return (
//     <NotificationContext.Provider
//       value={{ notifications, unreadNotifications, markAllAsViewed }}
//     >
//       {children}
//     </NotificationContext.Provider>
//   );
// };

import { createContext, useEffect, useState } from "react";
import io from "socket.io-client";
import baseURL from "../config.js";
import axios from './axiosInstance.js';

export const NotificationContext = createContext();

const socket = io("http://localhost:8000", {
  auth: {
    token: localStorage.getItem("token"),
  },
});

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const fetchNotifications = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/notifications`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setNotifications(res.data.notifications || []); // ensure it's always an array
    } catch (error) {
      console.error("Error fetching notifications", error);
    }
  };



  const markAllAsViewed = async () => {
    try {
      await axios.put(`${baseURL}/api/notifications/mark-all-viewed`);
      await fetchNotifications(); // refresh
    } catch (error) {
      console.error("Error marking notifications as viewed", error);
    }
  };

  const markNotificationAsViewed = async (notificationId) => {
    try {
      await axios.put(`${baseURL}/api/notifications/${notificationId}/mark-viewed`);
      await fetchNotifications(); // Refresh the notifications after marking one
    } catch (error) {
      console.error("Error marking notification as viewed", error);
    }
  };

  // const removeNotification = (id) => {
  //   setNotifications((prev) => prev.filter((notif) => notif._id !== id));
  // };

  const removeNotification = async (notificationId) => {
    try {
      await axios.put(`${baseURL}/api/notifications/${notificationId}/remove`);
      setNotifications((prev) => prev.filter((notif) => notif._id !== notificationId));
    } catch (error) {
      console.error("Error removing notification", error);
    }
  }
  
  useEffect(() => {
    fetchNotifications();

    socket.on("getNotification", (data) => {
      fetchNotifications(); // refresh on real-time message
    });

    return () => {
      socket.off("getNotification");
    };
  }, []);

  return (
    <NotificationContext.Provider value={{ notifications, markAllAsViewed, markNotificationAsViewed, removeNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};
